export default "__VITE_ASSET__CIgz7p1U__"